import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { SearchResultModel } from '../../models/query/search-result-model';
import { PaymentSearchModel } from '../../models/commerce/payment-search.model';
import { PaymentModel } from '../../models/commerce/payment.model';
import { BaseListService } from './base-list.service';
import { AiApiService } from '../ai-api.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentListService extends BaseListService {

  defaultPaymentListState: PaymentSearchModel = {
     sortColumnDirective: 'modifiedDate',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    sortColumn: 'modifiedDate',
    sortDirection: 'desc',
    sourceId: undefined,
    invoiceId: undefined,
    searchTerm: undefined
  };

  private _resultItems$ = new BehaviorSubject<PaymentModel[]>([]);
  protected override _state: PaymentSearchModel = { ...this.defaultPaymentListState };

  constructor(
    protected aiApiService: AiApiService) {
    //private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  get sourceId() { return this._state.sourceId; }
  get invoiceId() { return this._state.invoiceId; }

  set sourceId(sourceId: string | undefined) { this._setNoSearch({ sourceId }) }
  set invoiceId(invoiceId: string | undefined) { this._setNoSearch({ invoiceId }) }

  protected _search(): Observable<SearchResultModel<PaymentModel> | boolean | undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.aiApiService.getPaymentList(this._state);
  }

  override clearListService(): void {
    this._state = { ...this.defaultPaymentListState };
    this._resultItems$.next(new Array<PaymentModel>());
    this._total$.next(0);
  }
}
